import "whatwg-fetch";
import { push } from "react-router-redux";

import * as loadingActions from "admin/shared/commands/loading.actions";
import * as notificationActions from "admin/shared/notifications/commands/notification.actions";

import mockData from "./mockdata";

function callApi(
  endpoint,
  authenticatedRequest,
  method,
  contentType,
  data,
  token,
) {
  let config = { method: method };
  contentType = contentType ? contentType : "application/json";
  config.headers = { Accept: "application/json", "Content-Type": contentType };

  //Only application json gets stringified, other content types just pass data with additional cors mode check
  if (contentType != "application/json" && method != "GET") {
    config.body = data;
    config.mode = "cors";
  } else if (data && method != "GET") {
    var postData = Object.assign({}, data, { ...data });
    config.body = JSON.stringify(postData);
  }

  if (authenticatedRequest) {
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    } else {
      throw new Error("No token saved!");
    }
  }

  return fetch(endpoint, config).then((response) =>
    response
      .text()
      .then((resource) => ({ resource, response }))
      .then(({ resource, response }) => {
        if (response.status == 200 || response.status == 304) {
          return resource ? JSON.parse(resource) : {};
        } else {
          return Promise.reject({ resource, response });
        }
      }),
  );
}

export const CALL_API = Symbol("Call API");

export default (store) => (next) => (action) => {
  const callAPI = action[CALL_API];

  if (typeof callAPI === "undefined") {
    return next(action);
  }

  let {
    endpoint,
    types,
    authenticatedRequest,
    method,
    correlation,
    data,
    redirect,
    noLoading,
    mock,
    mockTimeout,
    polling,
    contentType,
    loadingType,
    retry,
    additionalData,
  } = callAPI;

  if (polling) {
    polling.times -= 1;
  }

  function actionWith(data) {
    const finalAction = Object.assign({}, action, data);
    delete finalAction[CALL_API];
    return finalAction;
  }

  let token = JSON.parse(localStorage.getItem("admin.usr")).access_token;

  if (!noLoading) {
    next(actionWith(loadingActions.show_loading(loadingType)));
  }

  if (mock) {
    let response = typeof mock === "string" ? mockData[mock] : mock;

    const [requestType, successType] = types;
    next(actionWith({ type: requestType, dataSent: data, correlation }));
    if (!noLoading) next(actionWith(loadingActions.hide_loading()));
    if (successType.method) {
      store.dispatch(successType.method(response, redirect));
    } else {
      let timeout = mockTimeout ? mockTimeout : 0;

      setTimeout(function () {
        next(
          actionWith({
            response: response,
            authenticatedRequest,
            type: successType,
            dataSent: data,
            correlation,
          }),
        );
        if (redirect) {
          store.dispatch(push(redirect));
        }
      }, timeout);
    }
    return;
  } else {
    return returnApiResponse(
      callApi,
      store,
      endpoint,
      authenticatedRequest,
      contentType,
      correlation,
      data,
      token,
      noLoading,
      next,
      actionWith,
      types,
      polling,
      redirect,
      method,
      loadingType,
      retry,
      additionalData,
    );
  }
};

//This wrapper part works fine but the number of parameters I think can be done better... [ToDo]
function returnApiResponse(
  callApi,
  store,
  endpoint,
  authenticatedRequest,
  contentType,
  correlation,
  data,
  token,
  noLoading,
  next,
  actionWith,
  types,
  polling,
  redirect,
  method,
  loadingType,
  retry,
  additionalData,
) {
  const [requestType, successType, failureType] = types;
  next(
    actionWith({
      type: requestType,
      dataSent: data,
      correlation,
      additionalData,
    }),
  );

  return callApi(
    endpoint,
    authenticatedRequest,
    method || "GET",
    contentType,
    data,
    token,
  )
    .then(
      (response) => {
        if (!noLoading)
          next(actionWith(loadingActions.hide_loading(loadingType)));
        if (successType.method) {
          if (polling) {
            if (polling.timeoutSuccessSet === true) {
              setTimeout(() => {
                store.dispatch(successType.method(response, redirect, polling));
              }, polling.timeout);
            } else {
              polling.timeoutSuccessSet = true;
              store.dispatch(successType.method(response, redirect, polling));
            }
          } else {
            store.dispatch(successType.method(response, redirect, polling));
          }
        } else {
          next(
            actionWith({
              response,
              authenticatedRequest,
              type: successType,
              dataSent: data,
              correlation,
              additionalData,
            }),
          );
          if (redirect) {
            next(actionWith(push(redirect)));
          }
        }
      },
      (error) => {
        //If there was an error try to retry the call if needed
        if (retry && retry.times) {
          retry.times = retry.times - 1;
          return setTimeout(() => {
            returnApiResponse(
              callApi,
              store,
              endpoint,
              authenticatedRequest,
              contentType,
              data,
              token,
              noLoading,
              next,
              actionWith,
              types,
              polling,
              redirect,
              method,
              loadingType,
              retry,
              additionalData,
            );
          }, retry.timeout);
        }
        let errorMessage = {};
        try {
          errorMessage = JSON.parse(error.resource);
          // eslint-disable-next-line no-unused-vars
        } catch (e) {
          /* empty */
        }

        if (Array.isArray(errorMessage)) {
          errorMessage = JSON.stringify(errorMessage);
        } else {
          errorMessage =
            error.message ||
            error.Message ||
            errorMessage.error ||
            errorMessage.Error ||
            errorMessage.errorMsg ||
            errorMessage.Message ||
            JSON.stringify(error);
        }

        next(actionWith({ type: "ERROR_NOTIFIACTION", message: errorMessage }));
        if (!noLoading)
          next(actionWith(loadingActions.hide_loading(loadingType)));
        if (failureType.method) {
          if (polling) {
            if (polling.timeoutErrorSet === true) {
              setTimeout(() => {
                store.dispatch(
                  failureType.method(errorMessage, redirect, polling),
                );
              }, polling.timeout);
            } else {
              polling.timeoutErrorSet = true;
              store.dispatch(
                failureType.method(errorMessage, redirect, polling),
              );
            }
          } else
            store.dispatch(failureType.method(errorMessage, redirect, polling));
        } else {
          next(
            actionWith({
              type: failureType,
              error: errorMessage,
              dataSent: data,
              correlation,
              additionalData,
            }),
          );
        }
        if (error.response && error.response.status == 500) {
          //Do something with error response
          next(
            actionWith({
              type: notificationActions.SERVER_ERROR,
              Text: errorMessage,
            }),
          );
        }
      },
    )
    .catch((error) => {
      //If there was an error try to retry the call if needed
      if (retry && retry.times) {
        retry.times = retry.times - 1;
        return setTimeout(() => {
          returnApiResponse(
            callApi,
            store,
            endpoint,
            authenticatedRequest,
            contentType,
            data,
            token,
            noLoading,
            next,
            actionWith,
            types,
            polling,
            redirect,
            method,
            loadingType,
            retry,
            additionalData,
          );
        }, retry.timeout);
      }

      let errorMessage = {};
      try {
        errorMessage = JSON.parse(error.resource);
        // eslint-disable-next-line no-unused-vars
      } catch (e) {
        /* empty */
      }

      if (Array.isArray(errorMessage)) {
        errorMessage = JSON.stringify(errorMessage);
      } else {
        errorMessage =
          error.message ||
          error.Message ||
          errorMessage.error ||
          errorMessage.errorMsg ||
          errorMessage.Message ||
          "An unknown error has occured";
      }

      if (!noLoading)
        next(actionWith(loadingActions.hide_loading(loadingType)));
      if (failureType.method) {
        if (polling) {
          if (polling.timeoutErrorSet === true) {
            setTimeout(() => {
              store.dispatch(
                failureType.method(errorMessage, redirect, polling),
              );
            }, polling.timeout);
          } else {
            polling.timeoutErrorSet = true;
            store.dispatch(failureType.method(errorMessage, redirect, polling));
          }
        } else
          store.dispatch(failureType.method(errorMessage, redirect, polling));
      } else {
        next(
          actionWith({
            type: failureType,
            error: errorMessage,
            dataSent: data,
            correlation,
          }),
        );
      }

      if (error.response && error.response.status == 400) {
        //Do something with error response
        //Change for popup
        alert(errorMessage);
      } else if (error.response && error.response.status == 500) {
        //Do something with error response
        //Change for popup
        alert(errorMessage);
      }
    });
}
